import { DimensionEnhancedSharedCost } from "@/store/dimensions/utils/types/common";
import { DimensionSharedCost } from "@/services/cloudchipr.api";
import { removeIdsFromFilterTreeItems } from "@/components/pages/common/filters-tree/utils/helpers/ids-manipulations/removeIdsFromFilterTreeItems";

export const generateSharedCostPayload = (
  sharedCost: DimensionEnhancedSharedCost,
): DimensionSharedCost => ({
  id: sharedCost.id,
  name: sharedCost.name,
  share_amounts: sharedCost.share_amounts,
  distribution_type: sharedCost.distribution_type,
  filter_tree: removeIdsFromFilterTreeItems(sharedCost.filter_tree),
});
